import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal, Button } from "lib/components/index";

import { stateSelector, open, close, submit } from "./index";
import EditOrderNotesModalForm from "./EditOrderNotesModalForm";

@connect(
  (state) => ({
    opened: stateSelector(state).opened,
    submitLoading: stateSelector(state).submitLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        open,
        close,
        submit,
      },
      dispatch
    )
)
export default class EditOrderNotesModal extends React.PureComponent {
  handleSave(newOrder) {
    const { close, onSave } = this.props;
    close();
    onSave(newOrder);
  }

  render() {
    const { opened, submitLoading, close, submit } = this.props;
    return (
      <Modal closeIcon closeOnDimmerClick={false} open={opened} onClose={close}>
        <Modal.Header>{I18n.t("papp.orders.EditOrderNotesModal.title")}</Modal.Header>
        <Modal.Content>
          <EditOrderNotesModalForm onSave={this.handleSave.bind(this)} />
        </Modal.Content>
        <Modal.Actions>
          <Button as="a" basic onClick={close} disabled={submitLoading} content={I18n.t("papp.common.cancel")} />
          <Button as="a" primary onClick={submit} disabled={submitLoading} content={I18n.t("papp.common.save")} />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/EditOrderNotesModal/EditOrderNotesModal.jsx